export default __webpack_public_path__ + "static/notserk_logo-header-335100288573a5bc225b7db82417890d.png";